import styled from "styled-components";

export const StyledPageWrap = styled.div`
  position: relative;
  width: 100%;
  background: none;
  text-align: center;
  margin: 50px auto;
  padding: 20px;

  p {
    display: block;
    font:
      15px/1.5 Arial,
      Sans-Serif;
    color: var(--acolor);
    margin: 0 0 30px 0;
    margin: 50px auto;
    text-align: center;
  }
  h1 {
    font:
      30px/1 Arial,
      Sans-Serif;
    color: var(--acolor);
    margin: 0 0 30px 0;
    margin: 50px auto;
    text-align: center;
    margin-top: 115px;
  }
  a {
    font:
      15px/1.5 Arial,
      Sans-Serif;
    color: var(--acolor);
    margin: 0 0 30px 0;
    margin: 50px auto;
    padding: 20px 38px;
    text-align: center;
  }
  a:hover {
    color: #f2d500;
  }

  @media (min-width: 576px) {
    width: 400px;
  }
`;
